module.exports = __webpack_public_path__ + "static/media/icomoon.26ab662b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon.woff?l3qv7r
// module id = 2761
// module chunks = 33